import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BehaviorSubject, map, Observable, skip} from 'rxjs';
import * as JSON5 from 'json5';
import {OnAppInitInterface, Utils} from '@astek/utils';
import {Config, ConfigJson} from './config';
import {ENVIRONMENT} from '../../../../environments/environment';

@Injectable()
export class ConfigService implements OnAppInitInterface<Observable<void>> {

  private _configSubject: BehaviorSubject<Config | null> = new BehaviorSubject<Config | null>(null);

  constructor(private readonly _httpClient: HttpClient) {
  }

  public get configChanged(): Observable<Config | null> {
    return this._configSubject.asObservable().pipe(skip(1));
  }

  public get config(): Config {
    if (Utils.isNullOrUndefined(this._configSubject.value)) {
      throw new Error('Config is not yet set');
    }
    return this._configSubject.value;
  }

  public get loading(): boolean {
    return Utils.isNullOrUndefined(this._configSubject.value);
  }

  public onAppInit(): Observable<void> {
    console.log('App environment:', ENVIRONMENT);

    return this._httpClient.get('assets/config/config.json5', {responseType: 'text'}).pipe(
      map((content: string): void => {
        const config: ConfigJson = JSON5.parse(content);
        this._configSubject.next(new Config(config));
        console.log('App config loaded', this.config);
      }),
    );
  }
}
